import { render, staticRenderFns } from "./SideContent.vue?vue&type=template&id=d2bd6072&"
import script from "./SideContent.vue?vue&type=script&lang=js&"
export * from "./SideContent.vue?vue&type=script&lang=js&"
import style0 from "./SideContent.vue?vue&type=style&index=0&id=d2bd6072&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports